import React from 'react';

const OfferTag = ({ className }) => {
  return (
    <svg
      className={className}
      width="9rem"
      height="2rem"
      viewBox="0 0 88 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0L88 0V14.0656H0L5.7541 7.03279L0 0Z"
        fill="#00A402"
      />
      <path
        opacity="0.6"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.72205e-06 0H0V14.0656H11.5082L5.7541 7.03279L11.5082 0H5.72205e-06ZM5.72205e-06 0L0 14.0656L5.7541 7.03279L5.72205e-06 0Z"
        fill="#77E078"
      />
    </svg>
  );
};

export default OfferTag;
